import {
  FaIndustry,
  FaBuilding,
  FaSeedling,
  FaBullseye,
  FaShieldAlt,
  FaFlask,
  FaHeadset,
} from 'react-icons/fa'
import Hero from '../components/Hero'
import { INDUSTRIES, VALUES } from '../content/homeContent'

const INDUSTRY_ICONS = {
  INDUSTRIAL: FaIndustry,
  COMMERCIAL: FaBuilding,
  AGRICULTURAL: FaSeedling,
}

const VALUE_ICONS = {
  'SPECIALTY EXPERTISE': FaBullseye,
  'COMPLIANCE DRIVEN': FaShieldAlt,
  'CUSTOM SOLUTIONS': FaFlask,
  'RESPONSIVE SUPPORT': FaHeadset,
}

export default function HomePage() {
  return (
    <>
      <Hero />

      <section className="industries" id="industries">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="industries__grid">
            {INDUSTRIES.map((item) => {
              const Icon = INDUSTRY_ICONS[item.title]
              return (
                <div key={item.title} className="industries__item">
                  <div className="industries__icon">
                    <Icon className="h-9 w-9 text-white" />
                  </div>
                  <div>
                    <h3 className="industries__title">{item.title}</h3>
                    <p className="industries__desc">{item.desc}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-t from-[#8a0000] to-aps-red py-10 lg:py-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {VALUES.map((item) => {
              const Icon = VALUE_ICONS[item.title]
              return (
                <div key={item.title} className="values-bar__item">
                  <Icon className="values-bar__icon" />
                  <div>
                    <h4 className="values-bar__title">{item.title}</h4>
                    <p className="values-bar__desc">{item.desc}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>
    </>
  )
}
